export type PageFilterHeaderTab = 'calendar' | 'goals' | 'benchmark' | 'trends' | 'compTrends'
